import PricingEngine from '@/components/PricingEngine/PricingEngine';
import { useTitle } from '@/contexts/AppContext';

export default function PricingEnginePage() {
  useTitle('Pricing Engine');
  return <PricingEngine />;
}
